import React from "react";
import PropTypes from "prop-types";
import { makeTreeItem } from "lib/common/components/TreeItem";
import classNames from "classnames/bind";
import { recordSourceTreeItemShape } from "./types";
import formatId from "lib/formatId";

class StateToggle extends React.PureComponent {
    render() {
        const {
            label,
            onClick,
            active,
            title,
        } = this.props;
        const disabled = onClick == null;
        const classes = classNames({
            "toggle-state": ! disabled,
            "toggle-state-placeholder": disabled,
            "checked": active
        });
        return <label
            onClick={disabled ? undefined : onClick}
            title={title}
        >
            <div
                className={classes}
            >
                <span />
            </div>
            {" "}
            {label}
        </label>;
    }
}

StateToggle.propTypes = {
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    title: PropTypes.string,
    onClick: PropTypes.func,
};

class CollapseHandle extends React.PureComponent {
    render() {
        const {
            onClick,
        } = this.props;
        const disabled = onClick == null;
        const classes = classNames({
            "collapse-handle": ! disabled,
            "collapse-handle-placeholder": disabled,
        });
        return <div
            className={classes}
            onClick={disabled ? undefined : onClick}
        >
            <span />
        </div>;
    }
}

CollapseHandle.propTypes = {
    onClick: PropTypes.func,
};

export class RecordSourceTreeGrid extends React.Component {
    constructor(props) {
        super(props);

        this.typesWithoutCheckBox = [
            "RECORD_MAPPING_TYPE_TARGET",
            "RECORD_MAPPING_TYPE_UPDATE",
            "RECORD_MAPPING_TYPE_PLACEHOLDER",
            "RECORD_MAPPING_TYPE_EXISTING"
        ];

        this.typesToHideChildren = [
            "RECORD_MAPPING_TYPE_REFERENCE"
        ];

        this.toggleState = this.toggleState.bind(this);
    }

    check(types, type) {
        return types.indexOf(type) < 0;
    }

    toggleState(e) {
        e.preventDefault();
        this.props.item.toggleActive();
    }

    render() {
        const {
            children,
            depth,
            isMagicRoot,
            label,
            old,
            parentType,
            shortname,
            type,
            value,
            forceActive,
            active,
            cid,
        } = this.props.item;

        const {
            expanded,
            toggleControl
        } = this.props;

        let itemView;
        if (!isMagicRoot && this.check(this.typesToHideChildren, parentType)) {
            let stateToggle;
            if (forceActive) {
                stateToggle = <StateToggle active title={forceActive} label={label} />;
            } else {
                stateToggle = <StateToggle active={active} onClick={this.toggleState} label={label} />;
            }

            let collapseHandle;
            if (this.check(this.typesToHideChildren, type) && children != null && children.length > 0) {
                collapseHandle = <CollapseHandle onClick={toggleControl} />;
            } else {
                collapseHandle = <CollapseHandle />;
            }

            const highlightNewValue = active || forceActive;

            itemView = (
                <div id={formatId(cid, "mr")} className="row item-view" data-shortname={shortname} data-control-type="mappingrow">
                    <div className="col-md-6 col-lg-8">
                        <div style={{
                            marginLeft: 25 * depth + "px",
                        }}>
                            <div className="target-entity-heading">
                                {collapseHandle}
                                {stateToggle}
                            </div>
                        </div>
                    </div>
                    <div className={`col-md-3 col-lg-2 new-value ${ highlightNewValue ? "active-value" : "inactive-value"}`}>{value}</div>
                    <div className={`col-md-3 col-lg-2 old-value ${!highlightNewValue ? "active-value" : "inactive-value"}`}>{old}</div>
                </div>
            );
        }

        let treeClasses;
        if (children) {
            treeClasses = classNames({
                "record-source-tree-grid": true,
                "parent": children.length > 0,
                "leaf": children.length === 0,
                "collapsed": !expanded,
            });
        } else {
            treeClasses = classNames({
                "record-source-tree-grid": true,
                "parent": false,
                "leaf": true,
                "collapsed": !expanded,
            });
        }

        return (
            <div className={treeClasses}>
                {itemView}
            </div>
        );
    }
}

RecordSourceTreeGrid.propTypes = {
    expanded: PropTypes.bool.isRequired,
    item: PropTypes.shape(recordSourceTreeItemShape).isRequired,
    toggleControl: PropTypes.func.isRequired
};

const RecordSourceTreeItem = makeTreeItem(RecordSourceTreeGrid);
export default RecordSourceTreeItem;



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcetreegrid/RecordSourceTreeItem.js